/* eslint-disable no-throw-literal */
import { all, fork } from "redux-saga/effects";
import serviceCenterSaga from "./serviceCenter/saga";
import policySaga from "./policy/saga";
import doctorSaga from "./doctor/saga";
import benefitsSaga from "./benefits/saga";
import accountSaga from "./account/saga";
import questionarySaga from "./questionary/saga";
import personalDoctorsSaga from "./personalDoctors/saga";
import relativesSaga from "./relatives/saga";
import productsSaga from "./products/saga";
import compensationsSaga from "./compensations/saga";
import appealsSaga from "./appeals/saga";
import profileCommonSaga from "./profileCommon/saga";
import commonSaga from "./common/saga";
import notificationsSaga from "./notifications/saga";

// Exporting all sagas as 1 root saga
export default function* rootSaga() {
  yield all([
    fork(serviceCenterSaga),
    fork(policySaga),
    fork(doctorSaga),
    fork(benefitsSaga),
    fork(accountSaga),
    fork(questionarySaga),
    fork(personalDoctorsSaga),
    fork(relativesSaga),
    fork(productsSaga),
    fork(compensationsSaga),
    fork(appealsSaga),
    fork(profileCommonSaga),
    fork(commonSaga),
    fork(notificationsSaga),
  ]);
}
